var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Urls) {pug_html = pug_html + "\u003Cdiv class=\"contextual-tooltip-container\"\u003E\u003Cdiv class=\"contextual-content\"\u003E";
// iterate Urls
;(function(){
  var $$obj = Urls;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
pug_html = pug_html + "\u003Clabel\u003E" + (pug.escape(null == (pug_interp = "URL " + (index+1) + ":") ? "" : pug_interp)) + "\u003C\u002Flabel\u003E\u003Cdiv class=\"urlContainer\"\u003E\u003Cspan class=\"url\"\u003E" + (pug.escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
pug_html = pug_html + "\u003Clabel\u003E" + (pug.escape(null == (pug_interp = "URL " + (index+1) + ":") ? "" : pug_interp)) + "\u003C\u002Flabel\u003E\u003Cdiv class=\"urlContainer\"\u003E\u003Cspan class=\"url\"\u003E" + (pug.escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"Urls" in locals_for_with?locals_for_with.Urls:typeof Urls!=="undefined"?Urls:undefined));;return pug_html;};
module.exports = template;